import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { data } from "../../utils/data.jsx";

const pages = data.pages;

const DesktopLinks = () => {
	return (
		<div className='w-450 xl:w-830 h-24 px-12 xl:pl-[123px] xl:pr-[165px] hidden md:flex items-center justify-between backdrop-blur-[80px]'>
			{pages.map((page) => (
				<div key={page.name} className='h-full relative flex flex-col items-center justify-center'>
					<NavLink to={page.to} className='flex gap-[10px]'>
						<p className='w-5 hidden xl:inline font-barlow font-bold text-16 leading-19 tracking-27 text-white'>
							{page.number}
						</p>
						<p className='font-barlow text-16 leading-19 tracking-27 text-white uppercase'>
							{page.name}
						</p>
					</NavLink>
					{page.to === window.location.pathname && (
						<motion.div
							className='absolute bottom-0 h-1 w-full bg-white'
							layoutId='active_indicator'
						/>
					)}
				</div>
			))}
		</div>
	);
};

export default DesktopLinks;
